import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { LoadingController, NavController } from 'ionic-angular';
import { DataProvider } from '../../providers/data/data';
import { RestProvider } from '../../providers/rest/rest';
import { Cow_Notification } from '../cow_notification/cow_notification';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  public Array = [];
  public Count: any;
  public Count_weight_unincluded: any;
  public Count_weight_included: any;
  public CowArray = [];

  public Er;
  public Em;
  public Date;
  public BASE_URL = 'http://localhost:8100/';
  loader: any;

  constructor(public navCtrl: NavController,
    private rest: RestProvider,
    private data: DataProvider,
    public loadingCtrl: LoadingController,
    public http: HttpClient,
    protected datepipe: DatePipe,
  ) {
  }


  notification(id) {
    console.log(id)
    this.navCtrl.push(Cow_Notification, {
      id: id
    });
  }

  showLoader(content?: string) {
    if (this.loader) {
      this.loader.dismiss();
    }
    this.loader = this.loadingCtrl.create({
      content: content ? content : "Ачаалж байна..."
    })
    this.loader.present();
    this.loader.onDidDismiss(() => {
      this.loader = null;
    })
  }
  hideLoader() {
    if (this.loader)
      this.loader.dismiss();
  }

  ionViewDidEnter(): void {
    document.getElementById('mainmenu').style.visibility = 'visible';
    document.getElementById('backmenu').style.display = 'none';
    document.getElementById('mainHeader').style.display = 'block';
    document.getElementById('backFrom').innerText = '';
    this.data.currentTabName = 'Мэдээлэл';
  }
  ionViewDidLoad() {
    this.showLoader();
    if (!localStorage.getItem('notifications_weight_unincluded')) {
      console.log('ehnii nohtsol')
      this.rest.Cows(localStorage.getItem('farmId')).subscribe(res => {
        console.log(res)
        this.Count = res.count[0].cow_count;
        localStorage.setItem('Cows', JSON.stringify(res));
        this.rest.CowGender().subscribe(
          (res) => {
            localStorage.setItem('CowGenderArray', JSON.stringify(res));
            this.rest.CowTypes().subscribe(
              (res) => {
                localStorage.setItem('CowTypesArray', JSON.stringify(res));

                this.rest.CowStatuses().subscribe(
                  (res) => {
                    localStorage.setItem('CowStatusesArray', JSON.stringify(res));

                    this.rest.CowBull().subscribe(
                      (res) => {
                        localStorage.setItem('BullArray', JSON.stringify(res));

                        this.rest.CowMother().subscribe(
                          (res) => {
                            localStorage.setItem('MotherArray', JSON.stringify(res));

                            this.rest.notifications_weight_unincluded(localStorage.getItem('farmId')).subscribe(
                              (res) => {
                                localStorage.setItem('notifications_weight_unincluded', JSON.stringify(res));
                                this.Count_weight_unincluded = res.length;
                              }
                            );
                            this.rest.notifications_weight_included(localStorage.getItem('farmId')).subscribe(
                              (res) => {
                                localStorage.setItem('notifications_weight_included', JSON.stringify(res));
                                this.Count_weight_included = res.length;
                              }
                            );
                            this.rest.simMasterTable().subscribe(
                              (res) => {
                                localStorage.setItem('simMasterTable', JSON.stringify(res));
                                this.hideLoader();
                              }
                            );
                          }
                        );
                      }
                    );
                  }
                );
              }
            );
          }, (err) => {
            this.hideLoader();
          }
        );
      },
        (err) => {
          console.log("ALDAA garsan")
          this.hideLoader();
          this.Count = JSON.parse(localStorage.getItem('Cows')).count[0].cow_count;
          this.Count_weight_unincluded = JSON.parse(localStorage.getItem('notifications_weight_unincluded')).length;
          this.Count_weight_included = JSON.parse(localStorage.getItem('notifications_weight_included')).length;
        }
      );
    } else {
      this.rest.Cows(localStorage.getItem('farmId')).subscribe(res => {
        localStorage.setItem('Cows', JSON.stringify(res));
        }
      );
      this.hideLoader();
      this.Count = JSON.parse(localStorage.getItem('Cows')).count[0].cow_count;
      this.Count_weight_unincluded = JSON.parse(localStorage.getItem('notifications_weight_unincluded')).length;
      this.Count_weight_included = JSON.parse(localStorage.getItem('notifications_weight_included')).length;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts